import request from '@/utils/request'

const api_name = '/admin/process/processTemplatePreference'

import qs from 'qs'

export default {
  //查询 偏好审批模板
  selectPreferenceTemplate() {
    return request({
      url: `${api_name}/selectPreferenceTemplate`,
      method: 'get',
    })
  },
  // 添加 偏好审批模板
  save(vo) {
    return request({
      url: `${api_name}/save`,
      method: 'post',
      data: vo,
    })
  },
  // 删除 偏好审批模板
  deletePreferenceTemplatetemplateId(templateId) {
    return request({
      url: `${api_name}/deletePreferenceTemplate`,
      method: 'delete',
      params: {
        templateId: templateId,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
    })
  },
}
